import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsHasAnIssue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsHasAnIssue: "/api/v1/portal/jobs/mark-as/toggle/has-an-issue/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  toggleMarkJobAsHasAnIssue() {
    return fetch(
      this.state.apiUrlForToggleMarkJobAsHasAnIssue+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }

  render() {
    return(
      <span>{(this.state.data.has_an_issue !== 1) ?
        <p>Job No issue<br />
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-green"
            title="Toggle Mark Job as has an issue"
            onClick={
              (e) => this.toggleMarkJobAsHasAnIssue(e)
            }
          >
            Mark Job as Has An Issue
          </button></p>
        :
        <p>
          <button className="btn btn-lg has-an-issue">
            Job has an issue &nbsp;{
            (this.state.data.marked_as_has_an_issue_by !== null) ?
              <span>
                      {
                        this.state.data.marked_as_has_an_issue_by.first_name+' '+
                        this.state.data.marked_as_has_an_issue_by.last_name+
                        ' on '+
                        this.state.data.marked_as_has_an_issue_at
                      }
                  </span>
              : ''
          }
          </button>&nbsp;
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-green"
            onClick={(e) => this.toggleMarkJobAsHasAnIssue(e)}
          >
            <i className="fa fa-undo"></i>&nbsp;
            Unmark Job as Has An Issue
          </button>
        </p>
      }
    </span>
    )
  }
}